import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import RadioField from '../../molecules/fields/RadioField'
import { componentOptions } from '../../../configs/officeHourConfig'

const AdditionalConfig = ({ name, label, hint, enabled, optionsSource, isReceptionDesk }) => {
  const options = useMemo(
    () =>
      optionsSource.map(el => {
        const Element = componentOptions[el]
        return { value: el, label: <Element isReceptionDesk={isReceptionDesk} /> }
      }),
    [optionsSource, isReceptionDesk]
  )

  return (
    <div className="flex flex-col gap-4">
      <RadioField
        name={name}
        label={label}
        hint={hint}
        options={options}
        defaultValue={options[0].value}
        disabled={!enabled}
      />
    </div>
  )
}

export default AdditionalConfig

AdditionalConfig.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  hint: PropTypes.string.isRequired,
  optionsSource: PropTypes.array.isRequired,
  enabled: PropTypes.bool,
  isReceptionDesk: PropTypes.bool
}
